import cssHasPseudo from "../../../node_modules/css-has-pseudo/dist/browser.mjs";
import "../../../node_modules/scroll-timeline-polyfill/dist/scroll-timeline.js";
import { WebpMachine } from "../../../node_modules/webp-hero/dist/webp-machine.js"

import "./imports.js";
import "../2021/modal.js";

//#region Polyfills

cssHasPseudo(document);
const webpMachine = new WebpMachine();
webpMachine.polyfillDocument();

//#endregion Polyfills.

const $$ = (selector, parent = document) => parent.querySelectorAll(selector);

const headings = $$("h1, h2");
const mediaQuery = window.matchMedia("(min-width: 1024px)");

if (mediaQuery.matches) {
  headings.forEach((heading, index) => {
    let delay = 20;
    let range = ["400", "700"];

    if (heading.classList.contains("display") || heading.classList.contains("home")) {
      range = ["330", "590"];
      delay = 0;
    }

    if (index === 0) {
      delay = 0;
      heading.animate({
        fontWeight: range}, {
        duration: 2000,
        easing: "ease-in-out",
        delay: delay,
        fill: "both"
      });
    } else {
      heading.animate({
        fontWeight: range}, {
        duration: 50,
        easing: "cubic-bezier(0.0, 0.0, 0.58, 1.0)",
        delay: delay,
        fill: "both",
        timeline: new ScrollTimeline({
          scrollOffsets: [{target: heading, edge: "end", clamp: true},
                          {target: heading, threshold: 1, clamp: true}],
          fill: "both",
        })
      });
    }
  });
}

window.addEventListener("scroll", () => {
  document.body.style.setProperty("--scroll", window.pageYOffset / (document.body.offsetHeight - window.innerHeight));
}, false);

const observer = new IntersectionObserver(changes => {
  changes.forEach(change => {
    // If the element is visible
    if (change.isIntersecting) {
      // Add the animation class
      change.target.classList.add("aos-animate");
      return; // If we added the class, exit the function
    }

    // We're not intersecting, so remove the class!
    change.target.classList.remove("aos-animate");
  });
}, {
  // trackVisibility: true,
  // delay: 100,
});

// Tell the observer which elements to track
document.querySelectorAll("[data-aos], .callout").forEach((target) => {
  target.classList.add("aos-init");
  observer.observe(target);
});
